import { useAuth } from '@rudi/auth';
import { Button } from '@rudi/ui/button';
import { ShieldAlert } from 'lucide-react';
import { clearSession } from '../platform/auth-storage';

export function NotAuthorized() {
  const { logout } = useAuth();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <ShieldAlert className="h-12 w-12 text-destructive" />
      <h1 className="text-xl font-semibold">Not authorized</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        Cortex is available to super admins. Tenant admins manage their organization in the
        Organization section of Rudi's settings.
      </p>
      <Button
        variant="outline"
        onClick={async () => {
          await logout();
          clearSession();
        }}
      >
        Sign out
      </Button>
    </div>
  );
}
